<template lang="html">
  <div tabindex="-1" :class="isFocus ? 'ky-editor-wrapper':''" @focusin="inProxy" @focusout="outProxy">
    <quill-editor v-model="content"
      ref="myQuillEditor"
      @change="onChange"
      :options="editorOption">
    </quill-editor>
    <el-dialog title="上传图片" size="tiny" :visible.sync="isUploadShow">
      <el-upload
        class="upload-demo"
        :headers = "uploadHeader"
        :action="uploadUrl"
        :show-file-list="false"
        :before-upload="beforeUpload"
        :on-success="importSuccess"
        :on-error="importError"
        >
        <el-button size="small" type="primary">点击上传</el-button>
        <div slot="tip" class="el-upload__tip">只能上传JPG/PNG文件，且大小不超过500K</div>
      </el-upload>
    </el-dialog>
  </div>
</template>

<script type="text/babel">
  import constants from 'config/constants'
  import sessionstorage from 'utils/sessionstorage'
  import urls from 'config/urls'
  // import CommonModel from 'models/common'
  // import date from 'utils/date'
  // VUE 富文本编辑器
  import {quillEditor} from 'vue-quill-editor'
  import 'quill/dist/quill.core.css'
  import 'quill/dist/quill.snow.css'
  import 'quill/dist/quill.bubble.css'

  export default {
    name: 'KyEditor',
    props: ['value'],
    components: {
      quillEditor
    },
    data () {
      return {
        uploadUrl: constants.basic.domain + urls.file.upload,
        uploadHeader: {},
        content: '',
        editorOption: {
          placeholder: '请输入内容……',
          modules: {
            toolbar: {
              container: [
                ['bold', 'italic', 'underline', 'strike'], // 加粗，斜体，下划线，删除线
                // ['blockquote', 'code-block'], // 引用，代码块
                // [{ 'header': 1 }, { 'header': 2 }], // 标题，键值对的形式；1、2表示字体大小
                [{ 'list': 'ordered' }, { 'list': 'bullet' }], // 列表
                [{ 'script': 'sub' }, { 'script': 'super' }], // 上下标
                [{ 'indent': '-1' }, { 'indent': '+1' }], // 缩进
                // [{ 'direction': 'rtl' }], // 文本方向
                [{ 'size': ['small', false, 'large', 'huge'] }], // 字体大小
                [{ 'header': [1, 2, 3, 4, 5, 6, false] }], // 几级标题
                [{ 'color': [] }, { 'background': [] }], // 字体颜色，字体背景颜色
                // [{ 'font': [] }], // 字体
                [{ 'align': [] }], // 对齐方式
                ['clean'], // 清除字体样式
                ['image'],
              ],
              handlers: {
                'image': this.customImageHandler
              }
            }
          }
        },
        isUploadShow: false,
        uploadForm: {key: '', token: ''},
        qiniuHost: '',
        isFocus: false
      }
    },
    computed: {
      editor () {
        return this.$refs.myQuillEditor.quill
      }
    },
    mounted () {
      sessionstorage.getItem('token').then(token => {
        if (!token) return
        this.uploadHeader = {Authorization: 'Bearer ' + token}
      })

      this.content = this.value
    },
    watch: {
      'value' (newVal, oldVal) {
        if (this.editor) {
          if (newVal !== this.content) {
            this.content = newVal
          }
        }
      },
    },
    methods: {
      customImageHandler () {
        this.isUploadShow = true
      },
      beforeUpload (file) {
        const isJPG = file.type === 'image/jpeg'
        const isPNG = file.type === 'image/png'
        if (!isJPG && !isPNG) {
          this.$message({ message: '文件不是JPG或者PNG格式', type: 'error' })
          return false
        }
        if (file.size > 1000 * 1024) {
          this.$message({ message: '文件超过了1M，无法上传', type: 'error' })
          return false
        }
        return true
      },
      importSuccess (res) {
        console.log(res)
        this.isUploadShow = false
        let index = this.editor.getSelection().index === null ? 0 : this.editor.getSelection().index
        this.editor.insertEmbed(index, 'image', constants.basic.domain_pic + res)
        this.$message({ message: '上传成功', type: 'success' })
      },
      importError () {
        this.$message({ message: '上传失败', type: 'error' })
      },
      onChange () {
        this.$emit('input', this.content)
      },
      inProxy: function (event) {
        this.isFocus = true
      },
      outProxy: function (event) {
        this.isFocus = false
      }
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus">
  .ky-editor-wrapper
    border: solid 1px  #46a0fc
</style>



// WEBPACK FOOTER //
// src/components/KyEditor.vue